/**
 * Feature-local TanStack QueryClient for admin-wallet (F-012 Phase 3).
 *
 * Mirrors `features/archivio/lib/query-client.ts`: the codebase has no global
 * app-wide QueryClient, so each feature scopes its own. Mounted per-page by
 * `AdminClientiPage` / `AdminUtenteDetailPage` via `QueryClientProvider`.
 *
 * A module-level singleton lets the cached `['admin','clienti']` list hydrate
 * (and invalidate) consistently with the `['admin','cliente',id]` detail when
 * navigating between the list and the detail page within the SPA session.
 */
import { QueryClient } from '@tanstack/react-query';

export function createAdminQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}

export const adminQueryClient = createAdminQueryClient();
